import { render, staticRenderFns } from "./spacecraftmap.vue?vue&type=template&id=0effecf1&scoped=true&"
import script from "./spacecraftmap.vue?vue&type=script&lang=ts&"
export * from "./spacecraftmap.vue?vue&type=script&lang=ts&"
import style0 from "./spacecraftmap.vue?vue&type=style&index=0&id=0effecf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0effecf1",
  null
  
)

export default component.exports